// node modules
import { Container, Row, Col } from "reactstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Controller, Navigation, Pagination } from "swiper";

// import Swiper and modules styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";

//style files
import "./index.scss";

const ParticipantsSection = () => {
  const logos = [
    "ak-gida-logo",
    "aksigorta-logo",
    "allianz-logo",
    "anadolu-efes-logo",
    "anadolu-hayat-emeklilik-logo",
    "anadolu-isuzu-logo",
    "arcelik-logo",
    "avon-logo",
    "bat-logo",
    "beiersdorf-logo",
    "borusan-logo",
    "bosch-logo",
    "bsh-logo",
    "cci-logo",
    "coca-cola-logo",
    "colgate-logo",
    "danone-logo",
    "deloitte-logo",
    "denizbank-logo",
    "dogus-logo",
    "eczacıbaşı-logo",
    "eti-logo",
    "ey-logo",
    "ford-otosan-logo",
    "golf-logo",
    "hayat-logo",
    "hepsiburada-logo",
    "ing-logo",
    "istegelsin-logo",
    "jti-logo",
    "kordsa-logo",
    "kpmg-logo",
    "lcw-logo",
    "loreal-logo",
    "marsh-logo",
    "mckinsey-company-logo",
    "mercedes-benz-logo",
    "migros-logo",
    "mondelez-logo",
    "nestle-logo",
    "odas-logo",
    "oyak-renault-logo",
    "p&g-logo",
    "pepsico-logo",
    "perfetti-logo",
    "pernod-ricard-logo",
    "pfizer-logo",
    "pladis-logo",
    "pmi-logo",
    "pwc-logo",
    "qnb-logo",
    "reckitt-logo",
    "sahibinden-logo",
    "samsung-logo",
    "schneider-logo",
    "sisecam-logo",
    "sistem-global-logo",
    "tei-logo",
    "tf-logo",
    "tide-logo",
    "tofas-logo",
    "turcell-logo",
    "turk-telekom-logo",
    "turkish-aerospace-logo",
    "turkiye-is-bankasi-logo",
    "unilever-logo",
    "vestel-logo",
    "vodafone-logo",
    "yandex-logo",
    "yapikredi-logo",
    "yildiz-holding-logo",
  ];

  const getItemOfScreenSize = (width) => {
    if (width < 600) {
      return 2;
    } else if (width < 800) {
      return 3;
    } else if (width < 1100) {
      return 4;
    } else {
      return 5;
    }
  };

  return (
    <section id="participants" className="participants-section">
      <Container data-aos="fade-up">
        <Row>
          <Col>
            <h3 className="title">PARTICIPANTS</h3>
          </Col>
          <Col style={{ position: "relative" }}>
            <Swiper
              modules={[Autoplay, Pagination, Controller, Navigation]}
              slidesPerView={getItemOfScreenSize(window.innerWidth)}
              spaceBetween={30}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              pagination={false}
              navigation={true}
              loop={true}
              loopFillGroupWithBlank={true}
              style={{ marginTop: "62px" }}
            >
              {logos.map((logo, index) => {
                return (
                  <SwiperSlide key={index}>
                    <img
                      src={require("../../../../assets/images/CareerPlus-Logolar-150x150/" +
                        logo +
                        ".png")}
                      alt={logo}
                    />
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ParticipantsSection;
